var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.531 3.46903C14.8673 5.80531 14.8673 10.1947 12.531 12.531C10.1947 14.8673 5.80531 14.8673 3.46903 12.531C1.13274 10.1947 1.13274 5.80531 3.46903 3.46903C5.80531 1.13274 10.1947 1.13274 12.531 3.46903ZM13.6637 2.33628C10.5487 -0.778761 5.45133 -0.778761 2.33628 2.33628C-0.778761 5.45133 -0.778761 10.5487 2.33628 13.6637C5.45133 16.7788 10.5487 16.7788 13.6637 13.6637C16.7788 10.5487 16.7788 5.45133 13.6637 2.33628ZM5.16814 9.69911C4.82832 10.0389 4.82832 10.492 5.16814 10.8319C5.50796 11.1717 6.0177 11.115 6.30088 10.8319L8 9.13274L9.69911 10.8319C10.0389 11.1717 10.492 11.1717 10.8319 10.8319C11.1717 10.492 11.115 9.9823 10.8319 9.69911L9.13274 8L10.8319 6.30089C11.1717 5.96106 11.1717 5.50796 10.8319 5.16814C10.492 4.82832 10.0389 4.82832 9.69911 5.16814L8 6.86726L6.30088 5.16814C5.96106 4.82832 5.50796 4.82832 5.16814 5.16814C4.82832 5.50796 4.82832 5.96106 5.16814 6.30088L6.86726 8L5.16814 9.69911Z",
    fill: "#FC4C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/Reject.e7a887415ac9c1e978db991d72d7fa1b.svg";
export { ForwardRef as ReactComponent };